import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../utils/api';

export function usePageview() {
  const location = useLocation();

  useEffect(() => {
    axios.post(`${API}/analytics/pageview`, { page: location.pathname }).catch(() => {});
  }, [location.pathname]);
}
